module.exports = __webpack_public_path__ + "img/play_circle_filled.f76db880.svg";